import React from 'react';
import { Upload, ImageIcon } from 'lucide-react';
import { cn } from '../../lib/utils';

interface UploadZoneProps {
  isDragging: boolean;
  onDragOver: (e: React.DragEvent) => void;
  onDragLeave: (e: React.DragEvent) => void;
  onDrop: (e: React.DragEvent) => void;
  onBrowseClick: () => void;
  fileInputRef: React.RefObject<HTMLInputElement | null>;
  onFileInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  allowedFormats: string[];
}

export const UploadZone: React.FC<UploadZoneProps> = ({
  isDragging,
  onDragOver,
  onDragLeave,
  onDrop,
  onBrowseClick,
  fileInputRef,
  onFileInputChange,
  allowedFormats,
}) => {
  return (
    <div className="space-y-2">
      <h3 className="text-xs font-semibold text-muted-foreground uppercase tracking-wide flex items-center gap-2">
        <Upload className="w-3 h-3" />
        Upload Images
      </h3>
      <div
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
        className={cn(
          "border-2 border-dashed rounded-lg p-4 text-center transition-all duration-200 cursor-pointer",
          isDragging
            ? "border-primary bg-primary/5 dark:bg-primary/10 scale-[1.02]"
            : "border-muted-foreground/25 hover:border-primary/50 hover:bg-muted/30 dark:hover:bg-gray-800/50"
        )}
        onClick={onBrowseClick}
      >
        <div className={cn(
          "w-10 h-10 mx-auto mb-2 rounded-full flex items-center justify-center transition-all",
          isDragging ? "bg-primary/20" : "bg-muted dark:bg-gray-700"
        )}>
          {isDragging ? (
            <Upload className="w-5 h-5 text-primary animate-bounce" />
          ) : (
            <ImageIcon className="w-5 h-5 text-muted-foreground" />
          )}
        </div>
        <p className="text-sm font-medium mb-1 text-foreground">
          {isDragging ? "Drop files here" : "Drop images or click"}
        </p>
        <p className="text-[10px] text-muted-foreground">
          {allowedFormats.join(', ')}
        </p>
        <input
          ref={fileInputRef}
          type="file"
          multiple
          accept={allowedFormats.join(',')}
          onChange={onFileInputChange}
          className="hidden"
        />
      </div>
    </div>
  );
};
